import { SET_INITIAL_USER, REMOVE_USER_DATA } from './constant';
import { api } from '../../service';
import { remove, set } from '../../utils/storage';
import { MAIN_TOKEN_KEY } from '../../constants/app';
import { auth } from '../../utils/firebase';

/**
 * Login with email and password.
 *
 * @param {string} email
 * @param {string} password
 * @returns
 */
export const login = (userInfo) => async (dispatch) => {
  try {
    const { data } = await api.post('/backoffice/login', userInfo);

    if (data && data.data) {
      // Get the custom token from the response
      const customToken = data.data.token || data.data.customToken;
      
      if (!customToken) {
        throw new Error('No token received from server');
      }

      // Use Firebase to exchange custom token for ID token
      const { signInWithCustomToken } = await import('firebase/auth');
      const userCredential = await signInWithCustomToken(auth, customToken);
      
      // Get the ID token
      const idToken = await userCredential.user.getIdToken();

      // Set the ID token into the localStorage
      set(MAIN_TOKEN_KEY, idToken);

      // Dispatch User Info with admin details
      dispatch({ type: SET_INITIAL_USER, payload: { ...data.data, token: idToken } });
      
      return data.data;
    }
    throw new Error('Invalid response from server');
  } catch (error) {
    const message = error.response
      ? error.response.data.moreInformation.error
      : error.message;
    throw new Error(message);
  }
};

/**
 * Logout from the dashboard and redirect to the login page.
 *
 * @param {Object} history
 * @param {Object} location
 * @returns
 */
export const logout = (navigate, location) => async (dispatch) => {
  console.log("enter logout")
  const { data } = await api.post(`/backoffice/logout`);

  if (data) {
    // remove token
    remove(MAIN_TOKEN_KEY);

    // Dispatch User Info.
    if (navigate && location) {
      navigate('/login', { replace: true });
    }
    // remove user data
    dispatch({ type: REMOVE_USER_DATA });
  }
};
